import { useCallback } from 'react';
import { Modal } from '@adc/parallax-component-library';

import i18n from '~/utilities/i18n';

/**
 * This hook displays a modal when there is a failed API Call. This can occur in the case of
 * no internet or an unexpected error or API server being down.
 */
const useApiError = () => {
  const showApiErrorModal = useCallback(() => {
    Modal.show({
      testID: 'Global.modals.errorCommunicatingServer',
      header: '',
      details: i18n.t('Global.modals.errorCommunicatingServer.body'),
      primaryAction: {
        label: i18n.t('Global.microcopy.common.okCap'),
      },
    });
  }, []);

  const showNetworkErrorModal = useCallback(() => {
    Modal.show({
      testID: 'Global.modals.internetConnectionError',
      header: '',
      details: i18n.t('Global.modals.internetConnectionError.body'),
      primaryAction: {
        label: i18n.t('Global.microcopy.common.okCap'),
      },
    });
  }, []);

  const showCustomError = useCallback((errorMessage: string) => {
    Modal.show({
      testID: 'Global.modals.customError',
      header: '',
      details: errorMessage,
      primaryAction: {
        label: i18n.t('Global.microcopy.common.okCap'),
      },
    });
  }, []);

  return { showApiErrorModal, showNetworkErrorModal, showCustomError };
};

export default useApiError;
